/** @jsxImportSource @emotion/react */
import 'twin.macro';

import { isEqual } from 'lodash';

import { ReactComponent as BinSvg } from 'assets/Icons/bin.svg';
import { ReactComponent as AddSvg } from 'assets/Icons/plus_icon.svg';
import {
  CustomSelectSearch,
  Option,
} from 'components/shared/CustomSelectSearch';
import { Hint } from 'components/shared/Hint';
import { ProgramIdOption, SimplecastProgramFilter } from 'utils/models';
import { defaultStyles } from '../Integrations/IntegrationFilter';

type Props = {
  filter: SimplecastProgramFilter;
  index: number;
  lastProgramFilterIndex: number;
  programIdOptions?: ProgramIdOption[];
  isLoading?: boolean;
  onSelectProgramId: (newValue: Option, index: number) => void;
  onAddNewFilter: () => void;
  onRemoveFilter: (index: number) => void;
};

export const SimplecastIntegrationFilterItem = ({
  filter,
  index,
  lastProgramFilterIndex,
  programIdOptions,
  isLoading = false,
  onSelectProgramId,
  onAddNewFilter,
  onRemoveFilter,
}: Props) => {
  const renderCustomOption = (option: ProgramIdOption) => (
    <div tw="flex flex-row">
      <div tw="max-w-[5.5rem] mr-4 flex">
        <img alt="" src={option.imageURL} />
      </div>

      <div tw="flex flex-col w-full">
        <div
          tw="text-15 font-black text-left text-sonnant-dark break-words"
          className="line-clamp-2"
        >
          {option.label}
        </div>
        <div tw="text-12">{option.value}</div>
      </div>
    </div>
  );

  return (
    <div tw="flex space-x-8">
      <div tw="flex flex-col pt-0! w-[27rem]">
        <div tw="flex flex-row items-center">
          <label tw="flex flex-nowrap text-16 mr-3">Podcast ID</label>
        </div>

        <div tw="flex flex-row w-full">
          <div tw="flex-1 relative w-full ">
            <CustomSelectSearch
              menuPortal
              options={programIdOptions}
              defaultValue={filter.programId}
              isLoading={isLoading}
              customStyles={defaultStyles}
              formatOptionLabel={renderCustomOption}
              onChange={(newValue: Option) => onSelectProgramId(newValue, index)}
              menuPlacement="bottom"
              canCreate={false}
            />
          </div>
        </div>
      </div>

      <div tw="flex flex-col pt-0! w-[27rem]">
        <div tw="flex flex-row items-center">
          <label tw="flex flex-nowrap text-16 mr-3">Podcast Name</label>
        </div>

        <div tw="flex flex-row w-full">
          <div tw="flex-1 relative">
            <input
              tw="flex"
              type="text"
              name="programName"
              disabled
              value={filter.programName}
            />
          </div>
        </div>
      </div>

      <div tw="flex flex-shrink-0 space-x-5">
        {isEqual(index, lastProgramFilterIndex) && (
          <Hint text="Add new podcast filter" enterDelay={100} leaveDelay={0}>
            <button
              onClick={() => onAddNewFilter()}
              tw="flex justify-center self-end mb-[1rem] pt-0! items-center cursor-pointer rounded-lg h-[4rem] w-[4rem]"
              className="btn btn-secondary"
            >
              <AddSvg tw="w-[3rem]" />
            </button>
          </Hint>
        )}
        <Hint text="Remove podcast filter" enterDelay={100} leaveDelay={0}>
          <button
            onClick={() => onRemoveFilter(index)}
            tw="flex justify-center self-end mb-[1rem] pt-0! items-center cursor-pointer h-[4rem] w-[4rem]"
            className="btn btn-secondary"
          >
            <BinSvg fill="red" />
          </button>
        </Hint>
      </div>
    </div>
  );
};
